import React, { useEffect } from "react";
import { useLanguage } from "../../contexts/LanguageContext";

/**
 * Forces English for DevTeam routes. Mount only under /dev/*.
 */
export const DevForceEnglish: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { lang, setLang } = useLanguage();

  useEffect(() => {
    if (lang !== "en") {
      void setLang("en");
    }
  }, [lang, setLang]);

  return <>{children}</>;
};
